import { baseUrl } from "../Constants";
import { makeDate } from "../utils";
export const soilDataTableHeaders = [
  { id: "id", numeric: true, disablePadding: false, label: "ID" },
  {
      id: "createdAt",
      numeric: false,
      disablePadding: true,
      label: "Time",
    },
  { id: "device", numeric: false, disablePadding: true, label: "Device" },
  { id: "farm", numeric: false, disablePadding: true, label: "Farm" },
  {
    id: "nitrogen",
    numeric: true,
    disablePadding: false,
    label: "N (mg/Kg)",
  },
  {
    id: "phosphorus",
    numeric: true,
    disablePadding: false,
    label: "P (mg/Kg)",
  },
  {
    id: "potassium",
    numeric: true,
    disablePadding: false,
    label: "K (mg/Kg)",
  },
  { id: "ph", numeric: true, disablePadding: false, label: "PH" },
  { id: "temp", numeric: true, disablePadding: false, label: "Temp(°C)" },
  {
    id: "moisture",
    numeric: true,
    disablePadding: false,
    label: "Relative Humidity (%RH)",
  },
  {
    id: "conductivity",
    numeric: true,
    disablePadding: false,
    label: "EC (us/cm)",
  },
  {
    id: "signalLevel",
    numeric: true,
    disablePadding: false,
    label: "Signal Level (dbm)",
  },

];

export const soilDataTableSchema = {
  id: { value: "", type: "number", label: "ID", readOnly: true },
  device: { value: "", type: "text", label: "Device" },
  nitrogen: { value: "", type: "number", label: "N" },
  phosphorus: { value: "", type: "number", label: "P" },
  potassium: { value: "", type: "number", label: "K" },
  ph: { value: "", type: "number", label: "PH" },
  temp: { value: "", type: "number", label: "Temperature" },
  moisture: { value: "", type: "number", label: "Relative Humidity" },
  conductivity: { value: "", type: "number", label: "EC" },
  signalLevel: { value: "", type: "number", label: "Signal Level" },
  createdAt: {
    value: "",
    type: "text",
    label: "Time",
    readOnly: true,
  },
};
export const createSoilDataRecord = (data) => {
  let record = {
    id: { value: data.soilData.id, type: "number", label: "ID", readOnly: true },
    createdAt: {
      value: makeDate(data.soilData.createdAt),
      type: "text",
      label: "Time",
      readOnly: true,
      width: 300
    },
    device: {
      value: data.soilData.device.number,
      type: "text",
      label: "Device",
      readOnly: true,
    },
    farm: {
      value: data.farm.name,
      type: "text",
      label: "Farm",
      readOnly: true,
    },
    nitrogen: {
      value: data.soilData.nitrogen,
      type: "number",
      label: "N",
      readOnly: true,
    },
    phosphorus: {
      value: data.soilData.phosphorus,
      type: "number",
      label: "P",
      readOnly: true,
    },
    potassium: {
      value: data.soilData.potassium,
      type: "number",
      label: "K",
      readOnly: true,
    },
    ph: {
      value: (data.soilData.ph * 0.01).toFixed(2),
      type: "number",
      label: "PH",
      readOnly: true,
    },
    temp: {
      value: (data.soilData.temp * 0.1).toFixed(2),
      type: "number",
      label: "Temperature",
      readOnly: true,
    },
    moisture: {
      value: (data.soilData.moisture * 0.1).toFixed(2),
      type: "number",
      label: "Relative Humidity",
      readOnly: true,
    },
    conductivity: {
      value: data.soilData.conductivity,
      type: "number",
      label: "EC",
      readOnly: true,
    },
    signalLevel: {
      value: (0.474 * data.soilData.signalLevel - 112).toFixed(2),
      type: "number",
      label: "Signal Level",
      readOnly: true,
    }
  };
  return record;
};

export const soilDataTableIdField = "id";
export const soilDataTableTitle = "Sensor";
export const soilDataBaseUrl = baseUrl + "soil-data";
export const soilDataFarmBaseUrl = baseUrl + "soil-data-farm";
